import { coerceCssPixelValue } from '@angular/cdk/coercion';
import {
  AfterContentInit,
  Component,
  ContentChild,
  ElementRef,
  HostBinding,
  OnDestroy,
  Renderer2,
} from '@angular/core';
import { Subject } from 'rxjs';

import { DialogContentComponent } from './dialog-content.component';
import { DialogHeaderComponent } from './dialog-header.component';

@Component({
    selector: 'lui-dialog-container',
    template: `
    <ng-content select="lui-dialog-header"></ng-content>
    <ng-content select="lui-dialog-content"></ng-content>
    <ng-content select="lui-dialog-actions"></ng-content>
  `,
    standalone: false
})
export class DialogContainerComponent implements AfterContentInit, OnDestroy {
  @HostBinding('class') hostClass = 'lui-dialog-container';

  @ContentChild(DialogHeaderComponent, { read: ElementRef })
  dialogHeaderElRef!: ElementRef;

  @ContentChild(DialogContentComponent, { read: ElementRef })
  dialogContentElRef!: ElementRef;

  observer!: ResizeObserver;

  private _destroy = new Subject<void>();

  constructor(private renderer: Renderer2) {}

  ngAfterContentInit(): void {
    this.observer = new ResizeObserver((entries) => {
      entries.forEach((entry) => {
        this._setContainerHeight(entry.borderBoxSize[0].blockSize);
      });
    });

    if (this.dialogHeaderElRef) {
      this.observer.observe(this.dialogHeaderElRef.nativeElement);
    }
  }

  ngOnDestroy(): void {
    if (this.dialogHeaderElRef) {
      this.observer.unobserve(this.dialogHeaderElRef.nativeElement);
    }
    this._destroy.complete();
  }

  private _setContainerHeight(height: number) {
    if (this.dialogContentElRef) {
      this.renderer.setStyle(
        this.dialogContentElRef.nativeElement,
        'max-height',
        `calc(100vh - ${coerceCssPixelValue(height + 80 + 80)})`
      );
    }
  }
}
